// Initialize asset file download on successful Formie form submission
// https://verbb.io/craft-plugins/formie/docs/developers/javascript-api

(function (window) {
  function initFormieForm(e) {
    const $form = e.detail.$form;
    initFormieDownload($form);
  }

  function initFormieDownload($form) {
    if ($form != null && $form.getAttribute('data-form') === 'downloadForm') {
      // Initialize asset download after successful form submission
      $form.addEventListener('onAfterFormieSubmit', (e) => {
        e.preventDefault();

        // Hide download file information on parent div
        const $formContainer = $form.closest('[data-form-container]');
        if ($formContainer) {
          $formContainer
            .querySelectorAll('[data-form-hide-on-submit]')
            .forEach((n) => n.remove());
        }

        // Show success message
        const $messageTemplate = $formContainer.querySelector(
          '[data-form-message]'
        );
        if ($messageTemplate) {
          const $clone = document.importNode($messageTemplate.content, true);
          $form.parentElement.insertBefore($clone, $form.nextSibling);
        }

        // Check if download url is available
        if (e.detail.assetUrl !== undefined && e.detail.assetUrl != '') {
          const $link = document.createElement('a');
          $link.href = e.detail.assetUrl;
          $link.target = '_blank';
          $link.dispatchEvent(new MouseEvent('click'));
        }
      });
    }
  }

  document.addEventListener('onFormieInit', initFormieForm);

  // Fallback for when the Formie script loads after onFormieInit has already fired.
  if (window.Formie && window.Formie.forms && window.Formie.forms.length) {
    window.Formie.forms.forEach(function (form) {
      initFormieDownload(form.$form);
    });
  }
})(this);
